import { createSelector, createSelectorMemoized } from "../../../utils/createSelector.es.js";
import { gridRowsLookupSelector } from "../rows/gridRowsSelector.es.js";
const gridSortingStateSelector = (state) => state.sorting;
const gridSortedRowIdsSelector = createSelector(gridSortingStateSelector, (sortingState) => sortingState.sortedRows);
const gridSortedRowEntriesSelector = createSelectorMemoized(
  gridSortedRowIdsSelector,
  gridRowsLookupSelector,
  // TODO rows v6: Is this the best approach ?
  (sortedIds, idRowsLookup) => sortedIds.map((id) => {
    var _idRowsLookup$id;
    return {
      id,
      model: (_idRowsLookup$id = idRowsLookup[id]) != null ? _idRowsLookup$id : {}
    };
  })
);
const gridSortModelSelector = createSelector(gridSortingStateSelector, (sorting) => sorting.sortModel);
const gridSortColumnLookupSelector = createSelectorMemoized(gridSortModelSelector, (sortModel) => {
  const result = sortModel.reduce((res, sortItem, index) => {
    res[sortItem.field] = {
      sortDirection: sortItem.sort,
      sortIndex: sortModel.length > 1 ? index + 1 : void 0
    };
    return res;
  }, {});
  return result;
});
export {
  gridSortColumnLookupSelector,
  gridSortModelSelector,
  gridSortedRowEntriesSelector,
  gridSortedRowIdsSelector
};
//# sourceMappingURL=gridSortingSelector.es.js.map
